import { render, staticRenderFns } from "./testPoint.vue?vue&type=template&id=46f96fa8&scoped=true&"
import script from "./testPoint.vue?vue&type=script&lang=ts&"
export * from "./testPoint.vue?vue&type=script&lang=ts&"
import style0 from "./testPoint.vue?vue&type=style&index=0&id=46f96fa8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46f96fa8",
  null
  
)

export default component.exports